import algoliasearch from 'algoliasearch'

// Internal

const ALGOLIA_API_ID = '0KNEMTBXX3'
const ALGOLIA_API_KEY = '43624fdefd3fd461b856bee1966d0f6a'
const ALGOLIA_INDEX_NAME = '_savoie_expo'

// External

export const ALGOLIA_CLIENT = algoliasearch(ALGOLIA_API_ID, ALGOLIA_API_KEY)

export const ALGOLIA_INDEX = ALGOLIA_CLIENT.initIndex(ALGOLIA_INDEX_NAME)
